import React, { useEffect, useState } from "react";

import Contact from "../components/Contact";
import FAQ from "../components/FAQ";
import Features from "../components/Features";
import Hero from "../components/Hero";
import Pricing from "../components/Pricing";
import Results from "../components/Results";
import Section_one from "../components/Section_one";
import Section_two from "../components/Section_two";

//translate
import { useTranslation } from "react-i18next";
import Modal from "../components/Modal";
import RoiCalculatorWidget from "../components/RoiCalculatorWidget";

const Landing = () => {
  const { t, i18n } = useTranslation();
  const [language, setLenguage] = useState("es");
  const [isOpen, setIsOpen] = useState(false);

  const onChangeLanguaje = () => {
    i18n.changeLanguage(language);
    if (language === "es") {
      setLenguage("en");
    } else {
      setLenguage("es");
    }
  };
  const cardshomenew = t("cardshomenew", { returnObjects: true });
  
  const cards = [
    {
      title: "Lealtad",
      text: "Te ofrecemos herramientas personalizables para llevar la lealtad de tus clientes al siguiente nivel",
      img: "https://img.invupos.com/clauweb/Hero/img1%20%281%29-Photoroom.png",
      overlay: "https://img.invupos.com/clauweb/Hero/img-overlay1.svg",
    },
    {
      title: "Wallet & NFC",
      text: "Los productos NFC son ideales para agilizar las transacciones y ofrecer soluciones modernas en el punto de venta.",
      img: "https://img.invupos.com/clauweb/Hero/img2%20%281%29-Photoroom.png",
      overlay: "https://img.invupos.com/clauweb/Hero/img-overlay2.svg",
    },
    {
      title: "E-commerce",
      text: "Te ofrecemos herramientas personalizables para llevar la lealtad de tus clientes al siguiente nivel",
      img: "https://img.invupos.com/clauweb/Hero/img3.png",
      overlay: "https://img.invupos.com/clauweb/Hero/img-overlay1.svg",
    },
  ];

  const items = [
    {
      number: "01",
      title: "Puntos y recompensas personalizadas",
      text: "Los clientes acumulan puntos, beneficios y recompensas exclusivas que motivan su regreso.",
      color: "bg-blue-200",
    },
    {
      number: "02",
      title: "Fidelización en cada compra",
      text: "Cada transacción es una oportunidad para conectar con el cliente mediante ofertas y mensajes personalizados.",
      color: "bg-amber-200",
    },
    {
      number: "03",
      title: "Pagos rápidos y sin fricción",
      text: "El wallet digital agiliza el pago y mejora la experiencia con un proceso simple y conveniente.",
      color: "bg-purple-200",
    },
  ];

  const integrations = [
    {
      name: "PedidosYa",
      logo: "https://img.invupos.com/webinvu/Integrations%20module/pedidosya.png",
    },
    {
      name: "Yappy",
      logo: "https://img.invupos.com/webinvu/Integrations%20module/yappy.png",
    },
    {
      name: "Visa",
      logo: "https://img.invupos.com/webinvu/Integrations%20module/visa.png",
    },
    {
      name: "Mastercard",
      logo: "https://img.invupos.com/webinvu/Integrations%20module/mastercard.png",
    },
    {
      name: "Invu POS",
      logo: "https://img.invupos.com/webinvu/Integrations%20module/invu.png",
    },
    {
      name: "Shipday",
      logo: "https://img.invupos.com/webinvu/Integrations%20module/shipday.png",
    },
    {
      name: "Uber Direct",
      logo: "https://img.invupos.com/webinvu/Integrations%20module/uberdirect.png",
    },
    {
      name: "American Express",
      logo: "https://img.invupos.com/webinvu/Integrations%20module/amex.png",
    },
    {
      name: "Picker",
      logo: "https://img.invupos.com/webinvu/Integrations%20module/picker.png",
    },
    {
      name: "PowerTranz",
      logo: "https://img.invupos.com/webinvu/Integrations%20module/powertranz.png",
    },
    {
      name: "ASAP",
      logo: "https://img.invupos.com/webinvu/Integrations%20module/asap.png",
    },
  ];

  // Reemplaza estas URLs por tus imágenes locales si es necesario
  const IPHONE_MOCKUP_URL =
    "https://img.invupos.com/clauweb/Hero%20new/image%202.png";
  const SVG_OVERLAY_URL =
    "https://img.invupos.com/clauweb/Hero/Vector%20128.svg";

  const LogoMarquee = ({
    speed = 48, // mayor = más sutil/lento
    gapRem = 3, // separación entre logos (rem)
  }) => {
    // Ajustes finos por marca (por si alguna es demasiado ancha/alta visualmente)
    // Puedes quitar/ajustar estas entradas si no las necesitas.
    const brandAdjust = {
      "Sushiexpress1.webp": "scale-90",
      "Elcosto.webp": "scale-90",
      "Grupotova.webp": "scale-90",
    };

    const logos = [
      // === 9 nuevos primero ===
      {
        src: "https://img.invupos.com/clauweb/Empresas/stevens.png",
        alt: "Stevens",
      },
      {
        src: "https://img.invupos.com/clauweb/Empresas/Powertranz.png",
        alt: "Powertranz",
      },
      {
        src: "https://img.invupos.com/clauweb/Empresas/Grand-deli-gourmet.png",
        alt: "Grand Deli Gourmet",
      },
      {
        src: "https://img.invupos.com/clauweb/Empresas/Olive-garden.png",
        alt: "Olive Garden",
      },
      {
        src: "https://img.invupos.com/clauweb/Empresas/sugoi.png",
        alt: "Sugoi",
      },
      {
        src: "https://img.invupos.com/clauweb/Empresas/Cafe%20duran.png",
        alt: "Café Durán",
      },
      {
        src: "https://img.invupos.com/clauweb/Empresas/Madison.png",
        alt: "Madison",
      },
      {
        src: "https://img.invupos.com/clauweb/Empresas/XING%20FU%20TANG.png",
        alt: "Xing Fu Tang",
      },
      { src: "https://img.invupos.com/clauweb/Empresas/Leto.png", alt: "Leto" },

      // === Los que ya tenías ===
      // { src: "https://img.invupos.com/clauweb/Partners/logos/cinnabon-1.webp", alt: "Cinnabon" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Sushiexpress1.webp", alt: "Sushi Express" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Elcosto.webp", alt: "El Costo" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Grupotova.webp", alt: "Grupo Tova" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/CredicorpBank_logo.webp", alt: "Credicorp Bank" },
      // { src: "https://img.invupos.com/clauweb/Partners/Tsugoi.webp", alt: "Tsugoi" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/FDCenter_logo.webp", alt: "FDCenter" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Bravapizza_logo.webp", alt: "Brava Pizza" },
    ];

    // Duplicamos dentro de UNA sola pista para loop perfecto sin “salto”
    const track = [...logos, ...logos];

    return (
      <div
        className="relative w-full overflow-hidden group"
        // máscara sutil para entradas/salidas suaves
        style={{
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
          maskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
        }}
      >
        <style>{`
        @keyframes marqueeX {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .marquee-track {
          display: flex;
          align-items: center;
          width: max-content;
          animation: marqueeX var(--marquee-duration, 48s) linear infinite;
          will-change: transform;
        }
        .marquee-track > * + * { margin-left: ${gapRem}rem; } /* separación entre “cajas” */
        .paused { animation-play-state: paused; }

        /* Respeta reduce motion */
        @media (prefers-reduced-motion: reduce) {
          .marquee-track { animation: none !important; transform: none !important; }
        }

        /* Ajuste leve por viewport para elegancia */
        @media (min-width: 1024px) {
          .marquee-root { --marquee-duration: ${speed + 6}s; }
        }
        @media (max-width: 480px) {
          .marquee-root { --marquee-duration: ${Math.max(30, speed - 6)}s; }
        }
      `}</style>

        <div className="marquee-root">
          <div className={`marquee-track group-hover:paused`}>
            {track.map((logo, i) => {
              // detectar nombre de archivo para ajuste fino opcional
              const filename = logo.src.split("/").pop() || "";
              const tweak = Object.keys(brandAdjust).find((key) =>
                filename.includes(key),
              );
              const scaleClass = tweak ? brandAdjust[tweak] : "";

              return (
                <div
                  key={i}
                  className="flex-shrink-0 flex items-center justify-center 
                           h-[68px] sm:h-[76px] lg:h-[86px]
                           w-[clamp(140px,12vw,240px)]" // caja uniforme
                >
                  <img
                    src={logo.src}
                    alt={logo.alt || ""}
                    loading="lazy"
                    className={`max-h-full max-w-full object-contain 

                    transition-all duration-300 ease-in-out
                    ${scaleClass}`}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {isOpen && <Modal setIsOpen={setIsOpen} />}
      <section className="relative w-full flex items-center overflow-hidden pt-10 pb-3">
        {/* Fondo con zoom */}
        {/* <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://img.invupos.com/clauweb/Hero/bg%20%281%29.png')",
            width: "120%",
            height: "120%",
            top: "-10%",
            left: "-10%",
            animation: "subtleMotion 20s ease-in-out infinite alternate",
          }}
        /> */}

        <div className="w-full max-w-screen-2xl mx-auto px-6">
          {/* 👇 Cambiamos proporción del grid */}
          <div className="grid lg:grid-cols-[46%_54%] items-center ">
            {/* LEFT */}
            <div className="max-w-xl z-10">
              <div className="inline-flex items-center bg-[#EC392A] backdrop-blur-md px-4 py-2 rounded-full shadow mb-6">
                <span className="text-sm text-white font-medium">
                  {t("HERO_BADGE")}
                </span>
              </div>

              <h1 className="text-4xl md:text-5xl xl:text-[57px] font-medium text-[#0B2B5C] leading-[1.15] mb-6">
                {t("HERO_TITLE_LINE1")}
                <br />
                {t("HERO_TITLE_LINE2")}{" "}
                <div className="relative inline-block px-2 py-1 group">
                  <span className="text-[#E73829] text-5xl font-extrabold">
                    CLAU.IO
                  </span>

                  <div className="absolute inset-0 border border-[#E73829] transition-all duration-500 group-hover:scale-105" />

                  <div className="absolute w-3 h-3 bg-[#E73829] top-0 left-0 -translate-x-1/2 -translate-y-1/2" />
                  <div className="absolute w-3 h-3 bg-[#E73829] top-0 right-0 translate-x-1/2 -translate-y-1/2" />
                  <div className="absolute w-3 h-3 bg-[#E73829] bottom-0 left-0 -translate-x-1/2 translate-y-1/2" />
                  <div className="absolute w-3 h-3 bg-[#E73829] bottom-0 right-0 translate-x-1/2 translate-y-1/2" />
                </div>
              </h1>

              <p className="text-gray-600 text-base md:text-lg mb-8 max-w-md">
                {t("HERO_DESCRIPTION")}
              </p>

              <button
                className="bg-[#E73829] hover:bg-[#ff5a4c] transition text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg"
                onClick={() => {
                  setIsOpen(true);
                }}
              >
                {t("HERO_CTA")}
              </button>
            </div>

            {/* RIGHT */}
            {/* <div className="relative flex justify-end">
            <img
              src="https://img.invupos.com/clauweb/Hero/Group%201597880418.png"
              alt="Clau App"
              className="w-[120%] max-w-none translate-x-10 drop-shadow-2xl"
            />
          </div> */}

            <div className="relative flex justify-center lg:justify-end">
              {/* 🎨 LÍNEAS */}
              <img
                src="https://img.invupos.com/clauweb/Hero%20new/cover-img-clau-3.png"
                alt=""
                className="
                absolute top-0 
                lg:left-auto lg:right-0 lg:translate-x-10
                w-[110%] sm:w-[115%] lg:w-[120%] max-w-none
                animate-lineDrawBlue
              "
              />

              <img
                src="https://img.invupos.com/clauweb/Hero%20new/cover-img-clau-4.png"
                alt=""
                className="
                absolute top-0 
                lg:left-auto lg:right-0 lg:translate-x-10
                w-[110%] sm:w-[115%] lg:w-[120%] max-w-none
                animate-lineDrawRed
              "
              />

              {/* 🧱 IMAGEN 1 */}
              <img
                src="https://img.invupos.com/clauweb/Hero%20new/cover-img-clau-1.png"
                alt="Clau App"
                className="
                relative z-10
                w-[110%] sm:w-[115%] lg:w-[120%] max-w-none
                mx-auto
                lg:mx-0
                lg:translate-x-10
                drop-shadow-2xl
                opacity-0 animate-img1
              "
              />

              {/* 🔝 IMAGEN 2 */}
              <img
                src="https://img.invupos.com/clauweb/Hero/cover-img-clau-3.png"
                alt=""
                className="
                absolute top-0
                left-1/2 -translate-x-1/2
                lg:left-auto lg:right-0 lg:translate-x-10
                w-[110%] sm:w-[115%] lg:w-[120%] max-w-none
                z-10
                opacity-0 animate-img2
              "
              />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="mt-10 mx-auto max-w-screen-2xl">
          <LogoMarquee speed={42} gapRem={2} />
        </div>
      </section>
      <section className="py-16 mt-10">
        <div className="max-w-screen-2xl mx-auto px-6">
          {/* TITLE */}
          <h2 className="text-center text-4xl md:text-5xl xl:text-6xl font-light text-[#1F2937] mb-16 leading-tight">
            {t("CARDS_SECTION_TITLE_LINE1")}
            <br />
            {t("CARDS_SECTION_TITLE_LINE2")}
          </h2>

          {/* CARDS */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
            {cardshomenew.map((card, index) => (
              <div
                key={index}
                className="relative bg-white rounded-3xl border border-gray-200 p-10 text-center hover:shadow-xl transition duration-300"
              >
                {/* Overlay decorativo */}
                <img
                  src={card.overlay}
                  alt=""
                  className="absolute top-0 left-0 w-full h-full object-cover 
                opacity-100 pointer-events-none
                animate-pulse"
                />

                {/* Imagen principal */}
                <div className="relative mb-6 flex justify-center">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-[140px] md:w-[240px]"
                  />
                </div>

                {/* Title */}
                <h3 className="text-2xl font-medium text-gray-800 mb-4 relative">
                  {card.title}
                </h3>

                {/* Text */}
                <p className="text-gray-600 text-base leading-relaxed relative">
                  {card.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-28 bg-[#F5F7FA] overflow-hidden">
        <div className="max-w-screen-2xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl xl:text-6xl font-light text-[#1F2937] mb-16">
                {t("WALLET_TITLE_LINE1")}{" "}
                <span className="text-[#FF0000] font-semibold">
                  {t("WALLET_TITLE_HIGHLIGHT")}{" "}
                </span>
                {t("WALLET_TITLE_LINE2")}
              </h2>
              {/* LEFT IMAGE */}
              <div className="relative flex justify-center lg:justify-center">
                <img
                  src="https://img.invupos.com/clauweb/Wallet_digital/WALLET-DIGITAL-5_tb3tqv.png"
                  alt="Digital Wallet"
                  className="w-[90%] max-w-[550px] drop-shadow-2xl"
                />
              </div>
              <div className="flex space-x-4 justify-center mt-4">
                <a>
                  <div className="w-36 h-20">
                    <img
                      src="https://img.invupos.com/clauweb/Landing/Add_to_Google_Wallet_badge.png"
                      alt="Download on the App Store"
                      className="w-full h-full object-contain"
                    />
                  </div>
                </a>
                <a>
                  <div className="w-36 h-20">
                    <img
                      src="https://img.invupos.com/clauweb/Landing/Add_to_Apple_Wallet_badge.png"
                      alt="Get it on Google Play"
                      className="w-full h-full object-contain"
                    />
                  </div>
                </a>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="relative">
              <div className="space-y-8 relative">
                {/* ITEM 1 — tarjeta a la derecha, número a la izquierda */}
                <div className="relative flex flex-col md:flex-row md:items-center">
  
  <span
    className="
      text-[60px] md:text-[80px]
      font-light text-gray-200 leading-none select-none
      mb-2 md:mb-0
      md:absolute md:-left-5
      md:top-1/2 md:-translate-y-1/2
    "
  >
    01
  </span>

  <div className="w-full md:ml-auto md:w-[85%] bg-white rounded-3xl p-8 shadow-md">
    <div className="flex items-start gap-4">
      <div className="w-10 h-10 rounded-full bg-[#FF0000] flex-shrink-0 mt-1" />
      <div>
        <h3 className="text-xl font-semibold mb-2 text-[#1F2937]">
          {t("WALLET_ITEM_1_TITLE")}
        </h3>
        <p className="text-gray-500 text-base leading-relaxed">
          {t("WALLET_ITEM_1_TEXT")}
        </p>
      </div>
    </div>
  </div>

</div>

                {/* ITEM 2 — tarjeta a la izquierda, número a la derecha */}
                <div className="relative flex flex-col md:flex-row md:items-center">

<span
  className="
    self-end
    text-[60px] md:text-[80px]
    font-light text-gray-200 leading-none select-none
    mb-2
    md:absolute md:-right-7
    md:top-1/2 md:-translate-y-1/2
  "
>
  02
</span>

<div className="w-full md:mr-auto md:w-[85%] bg-white rounded-3xl p-8 shadow-md">
  <div className="flex items-start gap-4">
    <div className="w-10 h-10 rounded-full bg-[#FF9719] flex-shrink-0 mt-1" />
    <div>
      <h3 className="text-xl font-semibold mb-2 text-[#1F2937]">
        {t("WALLET_ITEM_2_TITLE")}
      </h3>
      <p className="text-gray-500 text-base leading-relaxed">
        {t("WALLET_ITEM_2_TEXT")}
      </p>
    </div>
  </div>
</div>

</div>

                {/* ITEM 3 — tarjeta a la derecha, número a la izquierda */}
                <div className="relative flex flex-col md:flex-row md:items-center">

  <span
    className="
      text-[60px] md:text-[80px]
      font-light text-gray-200 leading-none select-none
      mb-2
      md:absolute md:-left-7
      md:top-1/2 md:-translate-y-1/2
    "
  >
    03
  </span>

  <div className="w-full md:ml-auto md:w-[85%] bg-white rounded-3xl p-8 shadow-md">
    <div className="flex items-start gap-4">
      <div className="w-10 h-10 rounded-full bg-[#007A36] flex-shrink-0 mt-1" />
      <div>
        <h3 className="text-xl font-semibold mb-2 text-[#1F2937]">
          {t("WALLET_ITEM_3_TITLE")}
        </h3>
        <p className="text-gray-500 text-base leading-relaxed">
          {t("WALLET_ITEM_3_TEXT")}
        </p>
      </div>
    </div>
  </div>

</div>
              </div>
            </div>
          </div>
        </div>
      </section>

            <div className="py-24">
      <RoiCalculatorWidget/>
      </div>

      <section className="py-16 bg-white overflow-hidden">
        <div className="max-w-screen-2xl mx-auto px-6">
          {/* CONTENEDOR CON BORDE */}
          <div className="border border-gray-200 rounded-3xl overflow-hidden relative">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              {/* LEFT CONTENT */}
              <div className="relative z-10 max-w-[600px] lg:pl-10  py-6 text-left p-8">
                <h2 className="text-5xl xl:text-6xl font-base text-[#1A1A2E] mb-6">
                  {t("CTA_TITLE")}
                </h2>
                <p className="text-gray-500 text-lg leading-relaxed mb-10 max-w-[500px]">
                  {t("CTA_DESCRIPTION")}
                </p>

                <button
                  className="inline-block bg-[#E73829] hover:bg-[#ff5a4c]222222r text-white font-medium text-base px-10 py-4 rounded-full transition-colors duration-200"
                  onClick={() => {
                    setIsOpen(true);
                  }}
                >
                  {t("CTA_BUTTON")}
                </button>
              </div>

              {/* RIGHT IMAGE */}
              <div className="relative flex justify-center lg:justify-center items-center min-h-[220px]">
                {/* Figura morada decorativa detrás */}
                <img
                  src="https://img.invupos.com/clauweb/Hero/Vector%20129.svg"
                  alt=""
                  aria-hidden="true"
                  className="absolute right-0 w-[100%] max-w-[980px] z-0 pointer-events-none  animate-lineDrawBlue"
                />

                {/* Imagen principal del kiosko */}
                <img
                  src="https://img.invupos.com/clauweb/Hero/cta%20img.png"
                  alt="Digital signage kiosk"
                  className="relative z-10 w-[60%] max-w-[480px] drop-shadow-xl"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-white pt-24 pb-16 px-6 lg:px-24 mt-12">
        {/* 1. Contenedor de Altura Completa (overflow-visible) */}
        <div className="max-w-7xl mx-auto relative flex flex-col lg:flex-row items-center justify-between rounded-[40px] p-8 lg:p-20 shadow-sm border border-gray-100 overflow-visible">
          {/* SVG de Fondo (El Overlay) */}
          <div className="absolute inset-0 z-0 opacity-40 pointer-events-none">
            <img
              src={SVG_OVERLAY_URL}
              alt="Fondo decorativo"
              className="w-full h-full object-cover"
            />
          </div>

          {/* --- Columna Izquierda: El iPhone desbordado --- */}
          {/* 2. Contenedor relativo de altura completa para posicionar */}
          <div className="relative z-20 w-full lg:w-1/2 flex justify-center lg:justify-start h-[300px] lg:h-auto mb-16 lg:mb-0">
            {/* 3. El teléfono real: Posicionado Absoluto para desbordar */}
            <div className="absolute top-0 transform -translate-y-1/3 lg:-translate-y-1/2 w-[280px] md:w-[350px]  drop-shadow-2xl">
              <img
                src={IPHONE_MOCKUP_URL}
                alt="Madison Pass App"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* --- Columna Derecha: Texto e Integraciones --- */}
          <div className="relative z-10 w-full lg:pl-10 lg:mt-0 mt-10 text-left space-y-8">
            <h1 className="text-4xl lg:text-5xl font-base text-gray-900 leading-tight">
              {t("INTEGRATIONS_TITLE_LINE1")}
              <br />
              <span className="text-gray-700">
                {t("INTEGRATIONS_TITLE_LINE2")}
              </span>
            </h1>

            <p className="text-lg text-gray-600 max-w-lg leading-relaxed">
              {t("INTEGRATIONS_DESCRIPTION")}
            </p>

            {/* Grid de Logotipos (Placeholders) */}
            <div className="grid grid-cols-3 md:grid-cols-5 gap-6 items-center opacity-100">
              <div className="flex items-center justify-center">
                <img
                  src="https://img.invupos.com/clauweb/Landing/pedidosya.png"
                  alt="PedidosYa"
                  className="h-8 w-auto object-contain"
                />
              </div>

              <div className="flex items-center justify-center">
                <img
                  src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Yappy-logo.png"
                  alt="Yappy"
                  className="h-8 w-auto object-contain"
                />
              </div>

              <div className="flex items-center justify-center">
                <img
                  src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Visa-logo.png"
                  alt="Visa"
                  className="h-8 w-auto object-contain"
                />
              </div>

              <div className="flex items-center justify-center">
                <img
                  src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Mastercard-logo.png"
                  alt="Mastercard"
                  className="h-8 w-auto object-contain"
                />
              </div>

              <div className="flex items-center justify-center">
                <img
                  src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Invu-logo.png"
                  alt="Invo POS"
                  className="h-8 w-auto object-contain"
                />
              </div>

              <div className="flex items-center justify-center">
                <img
                  src="https://img.invupos.com/clauweb/Landing_new/Uber-Direct-Deliverect-logo_cjnset.svg"
                  alt="Uber Direct"
                  className="h-8 w-auto object-contain"
                />
              </div>

              <div className="flex items-center justify-center">
                <img
                  src="https://img.invupos.com/clauweb/Landing/American_Express_logo.png"
                  alt="American Express"
                  className="h-8 w-auto object-contain"
                />
              </div>

              <div className="flex items-center justify-center">
                <img
                  src="https://img.invupos.com/clauweb/Landing_new/Picker_ob2le5.png"
                  alt="Picker"
                  className="h-8 w-auto object-contain"
                />
              </div>

              <div className="flex items-center justify-center">
                <img
                  src="https://img.invupos.com/clauweb/Landing_new/powerTranz_cseqyd.png"
                  alt="PowerTranz"
                  className="h-8 w-auto object-contain"
                />
              </div>

              <div className="flex items-center justify-center">
                <img
                  src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/ASAP-logo.png"
                  alt="ASAP"
                  className="h-8 w-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 lg:py-24 bg-white overflow-hidden lg:mt-10">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
          {/* HEADER */}
          <div className="text-center mb-12 md:mb-14 lg:mb-16">
            <h2 className="text-3xl md:text-4xl xl:text-6xl font-base text-[#1A1A2E] leading-tight mb-4 md:mb-5">
              {t("ECOM_TITLE_LINE1")}
              <br /> {t("ECOM_TITLE_LINE2")}
            </h2>
            <p className="text-gray-500 text-base md:text-lg max-w-[480px] mx-auto leading-relaxed">
              {t("ECOM_DESCRIPTION")}
            </p>
          </div>

          {/* MAIN */}
          <div
            className="relative 
      flex flex-col items-center gap-10
      md:grid md:grid-cols-2 md:gap-10
      lg:flex lg:min-h-[700px] lg:items-center lg:justify-center
    "
          >
            {/* BACKGROUND CIRCLE (solo desktop) */}
            <img
              src="https://img.invupos.com/clauweb/Hero/orange-circle.png"
              alt=""
              aria-hidden="true"
              className="hidden lg:block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[520px] opacity-100 pointer-events-none"
              style={{ animation: "slowPulse 6s ease-in-out infinite" }}
            />

            {/* LEFT CARDS */}
            <div
              className="
        flex flex-col gap-5 w-full max-w-[400px]
        md:order-1
        lg:absolute lg:left-[10%] lg:top-1/2 lg:-translate-y-1/2 lg:w-[220px]
      "
            >
              {/* Card 1 */}
              <div className="bg-white rounded-2xl p-5 md:p-6 shadow-lg border border-gray-100">
                <div className="mb-3">
                  <svg
                    className="w-7 h-7 md:w-8 md:h-8 text-[#1921C4]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <rect
                      x="2"
                      y="3"
                      width="20"
                      height="14"
                      rx="2"
                      strokeWidth="1.5"
                    />
                    <path d="M8 21h8M12 17v4" strokeWidth="1.5" />
                    <rect
                      x="7"
                      y="7"
                      width="4"
                      height="6"
                      rx="1"
                      strokeWidth="1.5"
                    />
                    <rect
                      x="13"
                      y="9"
                      width="4"
                      height="4"
                      rx="1"
                      strokeWidth="1.5"
                    />
                  </svg>
                </div>
                <h3 className="text-base md:text-lg font-bold text-[#1A1A2E] mb-2">
                  {t("ECOM_CARD1_TITLE")}
                </h3>
                <p className="text-gray-400 text-sm md:text-base leading-relaxed mb-4">
                  {t("ECOM_CARD1_TEXT")}
                </p>
                <button
                  className="bg-[#1921C4] text-white text-sm font-medium px-5 py-2 rounded-full"
                  onClick={() => setIsOpen(true)}
                >
                  {t("ECOM_CARD1_BUTTON")}
                </button>
              </div>

              {/* Card 2 */}
              <div className="bg-white rounded-2xl p-4 md:p-5 shadow-lg border border-gray-100 flex items-center gap-3">
                <svg
                  className="w-7 h-7 md:w-8 md:h-8 text-[#1921C4]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" strokeWidth="1.5" />
                  <path
                    d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                    strokeWidth="1.5"
                  />
                </svg>
                <div>
                  <p className="text-xl md:text-2xl font-bold text-[#1A1A2E]">
                    100%
                  </p>
                  <p className="text-gray-400 text-sm md:text-base">
                    {t("ECOM_CARD2_TEXT")}
                  </p>
                </div>
              </div>

              {/* Arrow (solo desktop) */}
              <img
                src="https://img.invupos.com/clauweb/Hero/Arrow-izquierda.png"
                alt=""
                aria-hidden="true"
                className="hidden lg:block absolute animate-bounce -bottom-16 right-4 w-16 opacity-80"
              />
            </div>

            {/* PHONE */}
            <div className="relative z-10 flex justify-center md:order-3 lg:order-none">
              {/* CIRCLE (mobile & tablet only) */}
              <img
                src="https://img.invupos.com/clauweb/Hero/orange-circle.png"
                alt=""
                aria-hidden="true"
                className="
                lg:hidden
                absolute
                top-1/2 left-1/2
                -translate-x-1/2 -translate-y-1/2
                w-[90vw] max-w-[420px]
                md:w-[420px]
                opacity-100
                pointer-events-none
                "
                style={{ animation: "slowPulse 6s ease-in-out infinite" }}
              />

              {/* PHONE IMAGE */}
              <img
                src="https://img.invupos.com/clauweb/Hero/iMockup%20-%20iPhone%2015%20Pro%20Max%20%281%29.png"
                alt="App E-commerce"
                className="relative z-10 w-[220px] md:w-[260px] xl:w-[320px] drop-shadow-2xl"
              />
            </div>

            {/* RIGHT CARDS */}
            <div
              className="
        flex flex-col gap-5 w-full max-w-[400px]
        md:order-2
        lg:absolute lg:right-[10%] lg:top-1/2 lg:-translate-y-1/2 lg:w-[220px]
      "
            >
              {/* Arrow (solo desktop) */}
              <img
                src="https://img.invupos.com/clauweb/Hero/Arrow-derecha.png"
                alt=""
                aria-hidden="true"
                className="hidden lg:block absolute animate-bounce -top-14 left-4 w-16 opacity-80"
              />

              {/* Card 3 */}
              <div className="bg-white rounded-2xl p-5 md:p-6 shadow-lg border border-gray-100">
                <div className="mb-3">
                  <svg
                    className="w-7 h-7 md:w-8 md:h-8 text-[#1921C4]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                      strokeWidth="1.5"
                    />
                  </svg>
                </div>
                <h3 className="text-base md:text-lg font-bold text-[#1A1A2E]">
                  {t("ECOM_CARD3_TITLE_LINE1")}
                  <br />
                  {t("ECOM_CARD3_TITLE_LINE2")}
                </h3>
              </div>

              {/* Card 4 */}
              <div className="bg-white rounded-2xl p-5 md:p-6 shadow-lg border border-gray-100">
                <div className="mb-3">
                  <svg
                    className="w-7 h-7 md:w-8 md:h-8 text-[#1921C4]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <rect
                      x="3"
                      y="3"
                      width="18"
                      height="18"
                      rx="2"
                      strokeWidth="1.5"
                    />
                    <path d="M12 8v8M8 12h8" strokeWidth="1.5" />
                  </svg>
                </div>
                <h3 className="text-base md:text-lg font-bold text-[#1A1A2E] mb-2">
                  {t("ECOM_CARD4_TITLE")}
                </h3>
                <p className="text-gray-400 text-sm md:text-base leading-relaxed mb-4">
                  {t("ECOM_CARD4_TEXT")}
                </p>
                <button
                  className="bg-[#E73829] text-white text-sm font-medium px-5 py-2 rounded-full"
                  onClick={() => setIsOpen(true)}
                >
                  {t("ECOM_CARD4_BUTTON")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="bg-white">
        <div class="max-w-screen-2xl px-6 py-6 mx-auto">
          <main class="relative z-20 w-full mt-8 md:flex md:items-center xl:mt-12">
            <div class="absolute w-full bg-[#F1F1F1] -z-10 md:h-[450px] rounded-3xl"></div>
            <div class="w-full p-6 bg-[#F1F1F1] md:flex md:items-center rounded-2xl md:bg-transparent md:p-0 lg:px-12 md:justify-evenly">
              <div class="mt-2 md:mx-6">
                <p class="text-4xl text-[#1d1d1f] md:text-5xl">
                  {t("LOYALTY_TITLE")}
                </p>
                <div className="mt-6">
                  <p className="font-light text-xl mt-3 tracking-normal leading-relaxed text-gray-700 max-w-2xl">
                    {t("LOYALTY_DESCRIPTION")}
                  </p>
                  <button
                    className="mt-6 inline-block rounded-full border border-[#FE7066] bg-[#E73829] hover:bg-[#ff5a4c] lg:px-12 px-8 py-3 text-sm md:text-lg font-medium text-white hover:bg-transparent hover:text-[#FFF] focus:ring-3 focus:outline-hidden"
                    onClick={() => {
                      setIsOpen(true);
                    }}
                  >
                    {t("LOYALTY_BUTTON")}
                  </button>
                </div>
              </div>
              <img
                class="md:mx-6 lg:mt-0 mt-12 object-cover md:h-[32rem] md:w-80 lg:h-[36rem] lg:w-[26rem] md:rounded-2xl"
                src="https://img.invupos.com/clauweb/Hero%20new/Group%201%20%288%29.png"
                alt="client photo"
              />
            </div>
          </main>
        </div>
      </section>
    </>
  );
};


export default Landing;
